import type { VisibleProfile } from "../types/participants";

export function isFieldVisible(
  visibility: string | null | undefined,
  isOrganizer: boolean,
  isSelf: boolean
): boolean {
  if (visibility === "all") return true;
  if (visibility === "organizer" && isOrganizer) return true;
  if (visibility === "self" && isSelf) return true;
  if (visibility === "private_organizer" && (isOrganizer || isSelf))
    return true;
  return false;
}

export function filterProfileForViewer(
  profile: any,
  viewerId: string,
  isOrganizer: boolean
): VisibleProfile {
  const isSelf = profile.id === viewerId;

  const visible: Partial<VisibleProfile> = {
    user_id: profile.id,
    email: profile.email ?? null,
    first_name: profile.first_name ?? "Unbekannt",
    last_name: profile.last_name ?? "",
    profile_picture_url: profile.profile_picture_url ?? null,
  };

  const allow = (field: string) =>
    isFieldVisible(profile[`${field}_visibility`], isOrganizer, isSelf);

  const safeAssign = (field: keyof VisibleProfile) => {
    if (allow(field)) visible[field] = profile[field];
  };

  [
    "allergies",
    "diet",
    "clothing_size",
    "medications",
    "notes",
    "birthdate",
    "gender",
    "languages",
    "has_insurance",
    "licenses",
    "notification_preference",
  ].forEach(safeAssign as (f: string) => void);

  if (allow("emergency_contact")) {
    visible.emergency_contact_name = profile.emergency_contact_name;
    visible.emergency_contact_phone = profile.emergency_contact_phone;
  }

  if (allow("can_swim")) {
    visible.can_swim = profile.can_swim;
  }

  return visible as VisibleProfile;
}
